module.exports = __webpack_public_path__ + "img/My network-icon.f4a0a179.svg";